export enum RPURequestStatusType {
  SUCCESS = 'success',
  IN_PROCESS = 'in_process',
  ERROR = 'error',
}
